export default function () {
    if (this.clear) {
        this.$store.commit('resetCastSearchResult')
        this.$store.commit('setCastSearchFilters', {})
    }

    if (this.$store.state.castSearchFilters) {
        this.filters = this.$store.state.castSearchFilters
    }

    this.searchProfessionals()
}
